import { Navigate } from 'react-router-dom';
import { STAFF_ROUTE } from '../../app/router/routes'

export default function AssistantsPage() {
    return <Navigate to={STAFF_ROUTE.path} replace />
}
